import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const getSlice = ({ consent }: GlobalState) => consent;

export const getBidderConsentSubmitted = createSelector(getSlice, ({ submitted }) => submitted);
